import CreateHRUser from "./pages/CreateHRUser";
import EditHRUser from "./pages/EditHRUser";
import ViewHRUser from "./pages/ViewHRUser";
import HRList from "./pages/HRList";

const hrRoutes = [
  {
    path: "/hr/users",
    element: <HRList />,
  },
  {
    path: "/hr/create-user",
    element: <CreateHRUser />,
  },
  {
    path: "/hr/view/:userId",
    element: <ViewHRUser />,
  },
  {
    path: "/hr/edit/:id",
    element: <EditHRUser />,
  },
];

export default hrRoutes;
